import React, { useState } from 'react';
import { Lock, Phone, Mail, Menu, X, Twitter, Linkedin, Instagram } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function SimonsHeader({
  activePage,
  setActivePage
}: {
  activePage: string;
  setActivePage: (p: any) => void;
}) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  return <nav className="sticky top-0 z-50 bg-white/90 backdrop-blur-xl border-b border-slate-100 px-6 py-4" data-id="element-55">
      <div className="max-w-7xl mx-auto flex items-center justify-between relative" data-id="element-56">
        <div className="flex items-center gap-3 cursor-pointer" onClick={() => {
        setActivePage('home');
        setMobileMenuOpen(false);
      }} data-id="element-57">
          <div className="w-24 h-24 rounded-lg overflow-hidden" data-id="element-58">
            <img src="https://cdn.magicpatterns.com/uploads/tMjEWqmYCwkaEDzp6B1BWr/ChatGPT_Image_May_14,_2026,_02_52_07_PM.png" alt="Simons Acquah Agency Logo" className="w-full h-full object-cover" data-id="element-59" />
          </div>
        </div>

        <div className="hidden lg:flex items-center gap-8 text-sm font-bold uppercase tracking-wider text-[#002366]" data-id="element-60">
          <button onClick={() => setActivePage('commercial')} className={`hover:text-[#DC143C] transition-colors ${activePage === 'commercial' ? 'text-[#DC143C]' : ''}`} data-id="element-61">
            Commercial
          </button>
          <button onClick={() => setActivePage('landlord')} className={`hover:text-[#DC143C] transition-colors ${activePage === 'landlord' ? 'text-[#DC143C]' : ''}`} data-id="element-62">
            Landlord
          </button>
          <button onClick={() => setActivePage('trucking')} className={`hover:text-[#DC143C] transition-colors ${activePage === 'trucking' ? 'text-[#DC143C]' : ''}`} data-id="element-63">
            Trucking
          </button>
          <button onClick={() => setActivePage('personal')} className={`hover:text-[#DC143C] transition-colors ${activePage === 'personal' ? 'text-[#DC143C]' : ''}`} data-id="element-64">
            Personal
          </button>
        </div>

        <div className="flex items-center gap-4" data-id="element-65">
          <button onClick={() => setActivePage('portal')} className="hidden lg:block px-5 py-2 bg-[#FFD700] text-[#002366] rounded-lg text-xs font-black uppercase tracking-widest hover:shadow-lg transition-all" data-id="element-66">
            Client Portal Login
          </button>
          <button onClick={() => setActivePage('quote')} className="hidden lg:block px-5 py-2 bg-[#DC143C] text-white rounded-lg text-xs font-bold uppercase tracking-widest hover:bg-[#B21031] transition-all shadow-lg shadow-[#DC143C]/20" data-id="element-67">
            Request Quote
          </button>

          {/* Mobile Menu Button */}
          <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="lg:hidden p-2 text-[#002366] hover:bg-slate-100 rounded-xl transition-colors" data-id="element-68">
            {mobileMenuOpen ? <X size={24} data-id="element-69" /> : <Menu size={24} data-id="element-70" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu Overlay */}
      <AnimatePresence data-id="element-71">
        {mobileMenuOpen && <motion.div initial={{
        opacity: 0,
        y: -10
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -10
      }} className="lg:hidden absolute top-full left-0 w-full bg-white border-t border-slate-100 px-6 py-8 shadow-2xl z-50" data-id="element-72">
            <div className="flex flex-col gap-6 text-lg font-bold text-[#002366]" data-id="element-73">
              {[{
            id: 'commercial',
            label: 'Commercial'
          }, {
            id: 'landlord',
            label: 'Landlord'
          }, {
            id: 'trucking',
            label: 'Trucking'
          }, {
            id: 'personal',
            label: 'Personal'
          }].map(item => <button key={item.id} onClick={() => {
            setActivePage(item.id);
            setMobileMenuOpen(false);
          }} className={`text-left hover:text-[#DC143C] transition-colors ${activePage === item.id ? 'text-[#DC143C]' : ''}`} data-id="element-74">
                  {item.label}
                </button>)}
            </div>

            <div className="pt-8 mt-8 border-t border-slate-100 flex flex-col gap-4" data-id="element-75">
              <button onClick={() => {
            setActivePage('portal');
            setMobileMenuOpen(false);
          }} className="w-full px-6 py-4 bg-[#FFD700] text-[#002366] rounded-xl text-sm font-black uppercase tracking-widest hover:shadow-lg transition-all" data-id="element-76">
                Client Portal Login
              </button>
              <button onClick={() => {
            setActivePage('quote');
            setMobileMenuOpen(false);
          }} className="w-full px-6 py-4 bg-[#DC143C] text-white rounded-xl text-sm font-bold uppercase tracking-widest hover:bg-[#B21031] transition-all shadow-lg shadow-[#DC143C]/20" data-id="element-77">
                Request Quote
              </button>
            </div>
          </motion.div>}
      </AnimatePresence>
    </nav>;
}
export function SimonsFooter({
  setActivePage
}: {
  setActivePage?: (p: any) => void;
}) {
  const handleNav = (e: React.MouseEvent, page: string) => {
    e.preventDefault();
    if (setActivePage) setActivePage(page);
  };
  return <footer className="bg-[#002366] text-white pt-20 pb-10 px-6" data-id="element-78">
      <div className="max-w-7xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-12 mb-20" data-id="element-79">
        <div className="col-span-2 md:col-span-1" data-id="element-80">
          <div className="flex items-center gap-3 mb-6 cursor-pointer" onClick={e => handleNav(e, 'home')} data-id="element-81">
            <div className="w-32 h-32 bg-white rounded-2xl overflow-hidden p-3 shadow-lg" data-id="element-82">
              <img src="https://cdn.magicpatterns.com/uploads/tMjEWqmYCwkaEDzp6B1BWr/ChatGPT_Image_May_14,_2026,_02_52_07_PM.png" alt="Simons Acquah Agency Logo" className="w-full h-full object-contain" data-id="element-83" />
            </div>
          </div>
          <p className="text-white/60 text-sm font-medium leading-relaxed max-w-xs" data-id="element-84">
            Strategic insurance solutions for the modern era. We protect your
            assets with precision and expertise.
          </p>
        </div>

        <div className="col-span-1" data-id="element-85">
          <h4 className="text-xs font-black uppercase tracking-[0.2em] text-[#FFD700] mb-6" data-id="element-86">
            Solutions
          </h4>
          <ul className="space-y-4 text-sm font-bold text-white/60" data-id="element-87">
            <li data-id="element-88">
              <a href="#" onClick={e => handleNav(e, 'commercial')} className="hover:text-white transition-colors" data-id="element-89">
                Commercial Auto
              </a>
            </li>
            <li data-id="element-90">
              <a href="#" onClick={e => handleNav(e, 'landlord')} className="hover:text-white transition-colors" data-id="element-91">
                Landlord Protection
              </a>
            </li>
            <li data-id="element-92">
              <a href="#" onClick={e => handleNav(e, 'trucking')} className="hover:text-white transition-colors" data-id="element-93">
                Cargo Insurance
              </a>
            </li>
            <li data-id="element-94">
              <a href="#" onClick={e => handleNav(e, 'personal')} className="hover:text-white transition-colors" data-id="element-95">
                Personal Bundles
              </a>
            </li>
          </ul>
        </div>

        <div data-id="element-96">
          <h4 className="text-xs font-black uppercase tracking-[0.2em] text-[#FFD700] mb-6" data-id="element-97">
            Contact
          </h4>
          <ul className="space-y-4 text-sm font-bold text-white/60" data-id="element-98">
            <li className="flex items-center gap-2" data-id="element-99">
              <Phone size={14} data-id="element-100" /> (555) 123-4567
            </li>
            <li className="flex items-center gap-2" data-id="element-101">
              <Mail size={14} data-id="element-102" /> info@simonsacquah.com
            </li>
            <li data-id="element-103">123 Strategic Way, Suite 100</li>
            <li data-id="element-104">New York, NY 10001</li>
          </ul>
        </div>

        <div data-id="element-105">
          <h4 className="text-xs font-black uppercase tracking-[0.2em] text-[#FFD700] mb-6" data-id="element-106">
            Resources
          </h4>
          <ul className="space-y-4 text-sm font-bold text-white/60" data-id="element-107">
            <li data-id="element-108">
              <a href="#" onClick={e => handleNav(e, 'claims')} className="hover:text-white transition-colors" data-id="element-109">
                Claims Center
              </a>
            </li>
            <li data-id="element-110">
              <a href="#" onClick={e => handleNav(e, 'blog')} className="hover:text-white transition-colors" data-id="element-111">
                Risk Blog
              </a>
            </li>
            <li data-id="element-112">
              <a href="#" onClick={e => handleNav(e, 'privacy')} className="hover:text-white transition-colors" data-id="element-113">
                Privacy Policy
              </a>
            </li>
            <li data-id="element-114">
              <button onClick={e => handleNav(e, 'portal')} className="flex items-center gap-2 text-[#FFD700] hover:text-white transition-colors" data-id="element-115">
                <Lock size={14} data-id="element-116" /> Agent Portal Login
              </button>
            </li>
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-117">
        <p className="text-[10px] font-bold text-white/40 uppercase tracking-widest" data-id="element-118">
          © 2026 Simons Acquah Agency. All rights reserved.
        </p>
        <div className="flex gap-4" data-id="element-119">
          <a href="#" className="w-10 h-10 bg-white/5 hover:bg-white/10 rounded-full flex items-center justify-center text-white/60 hover:text-white transition-all" data-id="element-120">
            <Twitter size={16} data-id="element-121" />
          </a>
          <a href="#" className="w-10 h-10 bg-white/5 hover:bg-white/10 rounded-full flex items-center justify-center text-white/60 hover:text-white transition-all" data-id="element-122">
            <Linkedin size={16} data-id="element-123" />
          </a>
          <a href="#" className="w-10 h-10 bg-white/5 hover:bg-white/10 rounded-full flex items-center justify-center text-white/60 hover:text-white transition-all" data-id="element-124">
            <Instagram size={16} data-id="element-125" />
          </a>
        </div>
      </div>
    </footer>;
}